import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  return <section id="failed-solutions" className="py-16 md:py-24 bg-white" data-id="element-53">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-55">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 text-gray-500 mb-6" data-id="element-56">
            <XCircle className="w-8 h-8" data-id="element-57" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2E1B] mb-6" data-id="element-58">
            WHY OTHER SERVICES HAVE FAILED YOU
          </h2>
          <div className="w-24 h-1 bg-gray-300 mx-auto rounded-full" data-id="element-59"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-60">
          <p data-id="element-61">We know you've tried before.</p>

          <p data-id="element-62">
            You called that guy someone recommended. He showed up late. Or
            didn't show up at all. Or showed up, mowed the grass quickly, and
            left without cleaning anything.
          </p>

          <p data-id="element-63">
            You searched Facebook Marketplace. Found someone cheap. And you got
            exactly what you paid for:{' '}
            <span className="font-semibold" data-id="element-64">a cheap job.</span>
          </p>

          <p className="text-xl font-bold text-[#1B2E1B] mt-8" data-id="element-65">
            The problem isn't you.
          </p>

          <p data-id="element-66">
            The problem is that most lawn services in Houston are just people
            with a mower and no commitment.
          </p>

          <ul className="space-y-4 my-8" data-id="element-67">
            <li className="flex items-center gap-3 text-gray-600" data-id="element-68">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-69" />
              <span data-id="element-70">No formal business.</span>
            </li>
            <li className="flex items-center gap-3 text-gray-600" data-id="element-71">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-72" />
              <span data-id="element-73">No insurance.</span>
            </li>
            <li className="flex items-center gap-3 text-gray-600" data-id="element-74">
              <XCircle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-75" />
              <span data-id="element-76">No accountability.</span>
            </li>
          </ul>

          <div className="bg-red-50 border border-red-100 p-6 rounded-xl text-center" data-id="element-77">
            <p className="font-bold text-red-800 text-xl" data-id="element-78">
              If something goes wrong with your property... they simply
              disappear.
            </p>
            <p className="text-red-600 mt-2" data-id="element-79">
              And you're left with the problem.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}